import { Stack } from '@mui/material';
import { z } from 'zod';

import { api } from 'common';

import { PatientJobParamsFormFields, PatientJobParamsSchema } from './Common/Patients';
import { type AsynchronousJobVariant, RequiredStringSchema } from './common';
import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';

import JobKind = api.RpaJob.Kind;

export const ExportHccFindingsVariant: AsynchronousJobVariant = {
  schema: z.object({
    jobKind: z.literal(JobKind.ExportHccFindings),
    payload: PatientJobParamsSchema.extend({
      hccFindingList: RequiredStringSchema,
    }),
  }),
  Config: () => {
    return (
      <Stack spacing={2}>
        <BlockValueTemplateField
          fieldName="config.payload.hccFindingList"
          label="Hcc Findings"
          helperText="Enter the reference to list of hcc findings. e.g. `{{findings.data}}`"
          placeholder="e.g. {{findings.data}}"
        />
        <PatientJobParamsFormFields />
      </Stack>
    );
  },
};
